<div class="period">
  <div class="period__title">{{ title }}</div>
  <div class="period__start">
    <app-datepicker
      [isStartDate]="true"
      [filter]="filterStart">
    </app-datepicker>
  </div>
  <div class="period__end">
    <app-datepicker [filter]="filterEnd"> </app-datepicker>
  </div>
</div>
